import React, { useEffect } from "react";
import { Route, Switch, Router } from "react-router-dom";
//import { Layout } from './components/LayoutMain';
import { FetchData } from "./components/FetchData";
import LoginPage from "./components/Login";
import RegisterPage from "./components/Register";
import Gestion from "./components/Gestion";
import Socios from "./components/Socios";
import Padron from "./components/Padron";
import Layout from "./components/Layout";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Facturacion from "./components/Facturacion";
import FacturacionHistory from "./components/FacturacionHistory";
import ProtectedRoute from "./components/ProtectedRoute";
import { ChakraProvider } from "@chakra-ui/react";
import { createBrowserHistory } from "history";
import { UserContextProvider } from "./State/UserContext";
import Informacion from "./components/InformacionPrestador";
import "./custom.css";
import NovedadesPrestador from "./components/novedadesPrestador";

export default function App() {
    const history = createBrowserHistory();

    useEffect(() => {
        //fetch("apiauth/getAppToken", {
        //    method: "GET",
        //    headers: { "Content-Type": "application/json" },
        //});
    })

    return (
        <UserContextProvider>
            <ChakraProvider>
                <Router history={history}>
                    <Switch>
                        <Route exact path="/" component={LoginPage} />
                        <Route exact path="/login" component={LoginPage} />
                        <Route path="/register" component={RegisterPage} />
                        <Route path="/forgotPassword" component={ForgotPassword} />
                        <Route path="/resetPassword" component={ResetPassword} />
                        <Layout>
                            <Switch>
                                <ProtectedRoute path="/socios" component={Socios} />
                                <ProtectedRoute path="/padron" component={Padron} />
                                <ProtectedRoute path="/gestion" component={Gestion} />
                                <ProtectedRoute path="/facturacion" component={Facturacion} />
                                <ProtectedRoute path="/facturacionHistory" component={FacturacionHistory} />
                                <ProtectedRoute path="/informacion" component={Informacion} />
                                {/*<ProtectedRoute path="/novedades" component={NovedadesPrestador} />*/}
                                <ProtectedRoute path="/fetch-data" component={FetchData} />
                            </Switch>
                        </Layout>
                    </Switch>
                </Router>
            </ChakraProvider>
        </UserContextProvider>
    );
}
